import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function getPropertiesByProject(projectId, params = {}) {
  const url = URL.setParams(URL.buildUrl(`projects/${projectId}/properties`), params);
  
  try {
    const response = await new API(url).get();
    return response;
  } catch (error) {
    throw error;
  }
}
